import { ReactNode } from 'react';

import { useSAMLEmptyState } from '@/hooks/useSAMLEmptyState';
import { cn } from '@/utils/tailwind';

interface SAMLEmptyStateWrapperProps {
  children: ReactNode;
  className?: string;
  disabledClassName?: string;
}

export const SAMLEmptyStateWrapper = ({
  children,
  className,
  disabledClassName = 'cursor-not-allowed opacity-50',
}: SAMLEmptyStateWrapperProps) => {
  const { isSAMLEmptyState } = useSAMLEmptyState();

  return (
    <div className={cn(className, isSAMLEmptyState && disabledClassName)}>
      {children}
    </div>
  );
};
